import React from 'react';
import { Typography } from '../../../../../electrons';
export function InputSubtitle({ className, subtitle }) {
    return subtitle ? (React.createElement(Typography, { className: className, variant: "body2" }, subtitle)) : null;
}
//# sourceMappingURL=InputSubtitle.js.map